/* 🤖 this file was generated by svg-to-ts */
export const matIconDiscFull: {
  name: 'disc-full';
  data: string;
} = {
  name: 'disc-full',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 7h2v5h-2zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm10-4h2v2h-2zm-10-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>`
};
